<template>
    <div class="q-pt-xl q-pb-xl">

      <q-card class="content-wrapper q-pr-xl q-pb-xl q-pl-xl q-pt-xs bg-grey-3" style="border-radius: 20px;">

        <div class="row top-title">
            <div class="col-xs-12 col-sm-12 col-md-12">
                <q-chip size="24px" rounded color="primary" text-color="white">REDEMPTION</q-chip>
            </div>
        </div>

        <q-card class="q-pa-sm bg-white" style="border-radius: 20px;">

          <q-card-section class="text-h5 text-bold">{{ transactionType }}</q-card-section>

          <q-separator spaced />

          <q-form @submit="submit">

            <fund-details-utf
              v-if="transactionType === 'UTF' && utf.length !== 0"
              class="q-px-md q-pb-md q-mt-md"
              ref="fundDetail"
              :appId=appId
              :customerId=customerId
              :accountId=accountId
              :userId=userId
              :channel=channel
              :fundName=fundName
              :currency=currency
              :holding=utf
              :plan=plan
              :scheme=scheme
              :isSelf=isSelf
              :env="env"
              :apiUrl="apiUrl"
              :notificationAPIToken="notificationAPIToken"
              :onelookAPIToken="onelookAPIToken"
              :cifAPIToken="cifAPIToken"
              :onboardingAPIToken="onboardingAPIToken"
              :transactionAPIToken="transactionAPIToken"
              :fundAPIToken="fundAPIToken"
              :agentEmail="agentEmail"
              @processing="toggleProgressBar"
            />

            <fund-details-prs
              v-if="transactionType === 'PRS' && prs.length !== 0"
              class="q-px-md q-pb-md"
              ref="fundDetail"
              :appId=appId
              :customerId=customerId
              :accountId=accountId
              :userId=userId
              :channel=channel
              :fundName=fundName
              :currency=currency
              :holding=prs
              :plan=plan
              :withdrawalReason=withdrawalReason
              :scheme=scheme
              :isSelf=isSelf
              :env="env"
              :apiUrl="apiUrl"
              :notificationAPIToken="notificationAPIToken"
              :onelookAPIToken="onelookAPIToken"
              :cifAPIToken="cifAPIToken"
              :onboardingAPIToken="onboardingAPIToken"
              :transactionAPIToken="transactionAPIToken"
              :fundAPIToken="fundAPIToken"
              :agentEmail="agentEmail"
              @processing="toggleProgressBar"
            />

            <q-separator />
            <q-linear-progress query v-if="isProcessing" />

            <q-card-actions align="center">
              <q-btn type="button" label="Cancel" class="q-mr-sm" color="negative" text-color="white" no-caps @click="cancel()" />
              <q-btn type="submit" label="Add To Cart" class="q-mr-sm" color="primary" text-color="white" no-caps :disable="isProcessing" />
            </q-card-actions>

          </q-form>

        </q-card>
      </q-card>

    </div>
</template>

<script>
import FundDetailsUtf from './FundDetailsUtf.vue'
import FundDetailsPrs from './FundDetailsPrs.vue'
import { QForm, QCard, QCardSection, QLinearProgress } from 'quasar'
import axios from 'axios'
import mixins from './mixin'

export default {

  name: 'Redemption',

  mixins: [mixins],

  components: {
    FundDetailsUtf,
    FundDetailsPrs,
    QForm,
    QCard,
    QCardSection,
    QLinearProgress
  },

  props: {
    appId: { type: String, required: true }, // Application ID ie. pkQkFqPYHd3azmey_QVCVQ
    customerId: { type: String, required: true }, // Customer ID ie. 610706085236
    accountId: { type: String, required: true }, // Account ID ie. 0016014
    scheme: { type: String, required: true }, // Scheme ie. SIPG
    transactionType: { type: String, required: true }, // Transaction Type ie. UTF/PRS
    plan: { type: String, required: true }, // Plan ie. EPF/CS/PRS
    currency: { type: String, required: true }, // Currency ie. MYR/SGD
    withdrawalReason: { type: String }, // Withdrawal Reason Code ie. R001
    agentId: { type: String }, // Agent id ie. RD20304
    isSophisticatedInvestor: { type: Boolean, required: true }, // Sophisticated Investor ie. true/false
    channel: { type: String, required: true }, // Application channel
    userId: { type: String, required: true }, // User Id
    accountHolding: { type: Array, required: false }, // Account Holding data
    isSelf: { type: Boolean, required: false, default: false }, // Is self transaction or not

    env: { type: String, required: false, default: 'development' },
    apiUrl: { type: String, required: false },
    notificationAPIToken: { type: String, required: true },
    onelookAPIToken: { type: String, required: true },
    cifAPIToken: { type: String, required: true },
    onboardingAPIToken: { type: String, required: true },
    transactionAPIToken: { type: String, required: true },
    fundAPIToken: { type: String, required: true },

    agentEmail: { type: String, required: true }
  },

  data () {
    return {

      // --- Props sample start --- //

      // appId: 'pkQkFqPYHd3azmey_QVCVQ',
      // customerId: '610706085236',
      // accountId: '0016014',
      // scheme: 'SIPG',
      // transactionType: 'UTF',
      // plan: 'CS',
      // currency: 'MYR',
      // withdrawalReason: 'R001',

      // --- Props sample end --- //

      fundName: '',
      prs: [],
      utf: [],
      isProcessing: true,
      cart: {}

    }
  },
  methods : {

    compileUtf(holdings) {

      // console.table(holdings)

      let utf = holdings.filter(item => {
        return item.Plan === this.plan
      })

      this.utf = this.combineUnitsAndAmount(utf)

    },

    compilePrs(holdings) {

      // console.table(holdings)
      
      let prsPlans = ['PRS30', 'PRS70', 'PRSGOV']
      prsPlans.forEach(plan => {

        let records = holdings.filter(item => {
          return item.Plan === plan
        })

        if (records.length > 0) {
          let combinedRecords = this.combineUnitsAndAmount(records)
          combinedRecords.plan = plan

          this.prs.push(combinedRecords)
        }

      });
    },

    combineUnitsAndAmount(records) {
      return {
        nav: records[0].NAV,
        asOfDate: records[0].AsOfDate,
        amount: records.reduce((total, item) => total + (item.AUM ? item.AUM : 0), 0),
        units: records.reduce((total, item) => total + (item.Units ? item.Units : 0), 0),
        floatingUnitsOut: records.reduce((total, item) => total + (item.FloatingUnitOut ? item.FloatingUnitOut : 0), 0),
        floatingUnitsIn: records.reduce((total, item) => total + (item.FloatingUnitIn ? item.FloatingUnitIn : 0), 0),
        submittedUnitsOut: records.reduce((total, item) => total + (item.SubmittedUnitOut ? item.SubmittedUnitOut : 0), 0),
        submittedUnitsIn: records.reduce((total, item) => total + (item.SubmittedUnitIn ? item.SubmittedUnitIn : 0), 0)
      }
    },

    submit() {
      
      const actionInput = this.$refs.fundDetail.$refs.action

      if (this.isTelegraphicTransfer(actionInput.paymentMethod.value) && actionInput.bankAccount.selected === '') {
        return alert('Please select a bank or add a new one.')
      }

      this.toggleProgressBar(true)
      
      let redemptionDetail = {
        Id: this.appId,
        TypeOfProduct: this.transactionType,
        AmountOrUnit: 'unit',
        Units: this.parseNumberToFloat(actionInput.inputUnits),
        SchemeCurrency: this.currency,
        Scheme: this.scheme,
        Plan: this.withdrawalReason === 'R003' && this.plan === 'PRS' ? 'PRS30' : this.plan,
        PaymentInstruction: actionInput.paymentMethod.value,
        BankAccountNumber: this.isTelegraphicTransfer(actionInput.paymentMethod.value) ? actionInput.bankAccount.selected.value.accNo : '',
        BankMICRCode: this.isTelegraphicTransfer(actionInput.paymentMethod.value) ? actionInput.bankAccount.selected.value.micrCode : '',
        PayeeName: this.isTelegraphicTransfer(actionInput.paymentMethod.value) ? actionInput.bankAccount.selected.value.accHolderName : '',
        CollectionMethod: '',
        WithdrawalReason: this.transactionType === 'PRS' ? this.withdrawalReason : '', // If prs
        EmployerCode: '', // !Yes
        ExitFees: 0, // for agent
        RedeemAll: false,
      }

      if (this.agentId)
        redemptionDetail.AgentCode = this.agentId

      this.$emit('submit', redemptionDetail)
      this.toggleProgressBar(false)
    },

    compile(holdings) {

      if (holdings.length === 0) 
        return alert('Record not found')

      this.fundName = holdings[0].ProductSchemeName

      if (this.transactionType === 'UTF') {
        let filtered = holdings.filter(item => {
          return item.Currency == this.currency && !item.Plan.includes('PRS')
        });
        this.compileUtf(filtered)
      }

      else {
        let filtered = holdings.filter(item => {
          return item.Currency == this.currency && item.Plan.includes('PRS')
        });
        this.compilePrs(filtered)
      }
    },

    cancel() {
        this.toggleProgressBar(false)
        this.$emit('cancel', 'Redemption cancelled!')
    },

    toggleProgressBar(payload) {
      this.isProcessing = payload
    },

    isTelegraphicTransfer(method) {
      return (method === 'TT' || method === 'FTT')
    }

  },

  mounted() {

    if (!this.accountId || !this.scheme) {
      return alert('Missing required props')
    }

    // Check for account holding props data, if not exist or empty, call from api
    if (this.accountHolding && this.accountHolding !== '') {
      const holdings = this.accountHolding
      this.compile(holdings)
    }

    else {
      // New Account Holding API: Fetch account holdings
      axios({
        method: 'GET',
        url: this.apiUrl + '/AUM/GetAccountHolding',
        params: {
          // pcustomerid: this.customerId,
          pinvestorid: this.accountId,
          pagentid: this.agentId ? this.agentId : null,
          excludechannelgroup: 'IUTA'
        },
        headers: {
          Authorization: 'Bearer ' + this.onelookAPIToken
        }
      })
      .then(resp => {

        if (!resp.data.GetAccountHoldingResult)
          return alert('API returned (null)')

        const holdings = resp.data.GetAccountHoldingResult.filter(item => item.Scheme === this.scheme && item.NAV !== 0)
        this.compile(holdings)

      })
      .catch(err => console.log(err))
    }

  }

}
</script>

<style>
.top-title {
  position: relative;
  top: -30px;
  z-index: 1;
  text-align: center;
  font-weight: bold;
}

@media only screen and (max-width: 599px) {
  .content-wrapper {
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
